export default {
    Metadata: {
        Name: "Sin",
        Description: "Returns the sine of a number.",
        Syntax: "Sin(number)",
        Keywords: ['Math'],
        Author: "DataVoke, Inc.",
    },
    execute(ofValue) {
        return Math.sin(ofValue);
    },
};

